import { types } from 'mobx-state-tree';

const PolarisConfig = types
  .model('PolarisConfig', {
    id: types.identifierNumber,
    externalUrl: types.string,
    internalUrl: types.string,
    polarisUsername: types.string,
    polarisKey: types.string,
    staffDomain: types.string,
    staffUsername: types.string,
    staffPassword: types.string,
    logonWorkstationId: types.string,
    notificationHandling: types.boolean,
    bounceHandlingType: types.string,
    spamHandlingType: types.string,
    bounceListId: types.string,
    spamListId: types.string,
    noteHandlingType: types.string
  }).views(self => {
    return {
      get editableFields() {
        return {
          externalUrl: self.externalUrl,
          internalUrl: self.internalUrl,
          polarisUsername: self.polarisUsername,
          polarisKey: self.polarisKey,
          staffDomain: self.staffDomain,
          staffUsername: self.staffUsername,
          staffPassword: self.staffPassword,
          logonWorkstationId: self.logonWorkstationId,
          notificationHandling: self.notificationHandling,
          bounceHandlingType: self.bounceHandlingType,
          spamHandlingType: self.spamHandlingType,
          bounceListId: self.bounceListId,
          spamListId: self.spamListId,
          noteHandlingType: self.noteHandlingType
        }
      }
    }
  });

export default PolarisConfig;
export type IPolarisConfig = typeof PolarisConfig.Type;